import { t } from 'services/translation';
import styled from '@emotion/styled';
import { isActionKey } from 'ui_system/utilities/KeyboardHelpers';
import { colors, shape } from 'ui_system/compass';
import { MultiSelectGuestOption } from './MultiSelectGuestOption';

interface MultiSelectGuestDesktopProps {
  guestList: Guest[];
  isMobile: boolean;
  removeGuest: any;
  multiSelectDone: () => void;
  units: any[];
  addGuest: (data: any) => void;
  updateGuest: (data: any) => void;
  onUpdateGuestDetail: () => void;
  country: string;
  slotTicketCapacities: SlotTicketCapacity[];
}

export interface SlotTicketCapacity {
  id: number;
  availability: number;
  unit_name: string;
  is_ticket_capacity_enabled: boolean;
  places_reserved: number;
  ticket_capacity_id: number;
  unit_type_id: number;
  units_reserved_for_confirmed_bookings: number;
  units_reserved_for_pending_bookings: number;
}

interface Guest {
  id: number;
  uiId: string;
  name: string;
  isPrimary: boolean;
  unitType: number;
  ticketUnitType: string;
  ticketPrice: string;
  ticketUniqId: string;
}

const DoneWrapper = styled.div`
  margin-top: 16px;
  text-align: center;
`;

const DoneButton = styled.button`
  background-color: ${colors.primary};
  border-radius: ${shape.borderRadius};
  color: ${colors.white};
  height: 44px;
  font-size: 16px;
  width: 120px;
  padding: 0.8em 1.5em;
  font-weight: 400;
  font-style: normal;
  vertical-align: baseline;
  cursor: pointer;
  display: inline-block;
  min-height: 1em;
  line-height: 1;
  border: none;
`;

export const MultiSelectGuestDesktop = ({
  guestList,
  isMobile,
  removeGuest,
  multiSelectDone,
  units,
  addGuest,
  updateGuest,
  onUpdateGuestDetail,
  country,
  slotTicketCapacities = [],
}: MultiSelectGuestDesktopProps): JSX.Element => {
  return (
    <>
      <MultiSelectGuestOption
        guestList={guestList}
        isMobile={isMobile}
        removeGuest={removeGuest}
        units={units}
        addGuest={addGuest}
        updateGuest={updateGuest}
        onUpdateGuestDetail={onUpdateGuestDetail}
        country={country}
        slotTicketCapacities={slotTicketCapacities}
      />
      <DoneWrapper>
        <DoneButton
          onClick={multiSelectDone}
          onKeyDown={(e) => isActionKey(e.key) && multiSelectDone()}
        >
          {t('DONE')}
        </DoneButton>
      </DoneWrapper>
    </>
  );
};
